import {Period} from '@/modules/neodash/model/types/interfaces/Period';
import {MonthsEnum} from '@/modules/neodash/model/types/enums/monthsEnum';
import * as moment from 'moment';

const qtyYearsOnReports = 3;
const today = new Date();

export const periodLimits: Period = {
  initial: {
    month: MonthsEnum.January,
    year: moment().add((qtyYearsOnReports * -1) + 1, 'years').get('year')
  },
  final: {
    month: today.getMonth(),
    year: today.getFullYear()
  }
};

export const minDate: Date = new Date(periodLimits.initial.year, periodLimits.initial.month);
export const maxDate: Date = new Date(periodLimits.final.year, periodLimits.final.month);
